// @flow

import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles, Tab, Tabs} from '@material-ui/core';
import {colors} from '../../../../../../../assets/styles/colors';

type Props = {
  value?: number,
  setTabSelected: (v: number) => void,
};

const useStyles = makeStyles(theme => ({
  chatTab: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    '&:hover': {
      color: colors.purple3,
      opacity: 1,
    },
    '&:focus': {
      color: colors.purple3,
    },
    '&.Mui-selected > span': {
      color: colors.purple3,
      fontWeight: 600,
    },
  },
}));

export default function ChatTabs({value, setTabSelected}: Props) {
  const classes = useStyles();
  return (
    <Tabs
      value={value}
      onChange={(_, v) => setTabSelected(v)}
      variant="fullWidth"
      indicatorColor="primary"
    >
      <Tab fullWidth label="Chat" classes={{root: classes.chatTab}} />
      {/* <Tab fullWidth label="Tareas" classes={{root: classes.chatTab}} /> */}
    </Tabs>
  );
}

ChatTabs.propTypes = {
  value: PropTypes.number.isRequired,
  setTabSelected: PropTypes.func.isRequired,
};
